export const removePlusPrefixOfPhone = (phoneNumber: string): string => {
  return phoneNumber.replace(/(\+|%2B)/gi, '')
}
